<section class="payment-register" role="dialog" aria-modal="true" aria-labelledby="payment-register-title">
  <button type="button" class="payment-register__close" aria-label="Cerrar" (click)="close()">×</button>
  <header class="payment-register__match">
    <img src="https://deportivo-municipal.s3.us-east-2.amazonaws.com/municipal-logos/municipal.png" alt="Deportivo Municipal" />
    <div><small>PRÓXIMO PARTIDO</small><strong>DEP. MUNICIPAL <i>VS</i> JOSÉ GÁLVEZ</strong><span>18 OCT 2026 · 13:00 · ESTADIO MUNICIPAL DE CHORRILLOS (COCHARCAS)</span></div>
    <img src="https://deportivo-municipal.s3.us-east-2.amazonaws.com/municipal-logos/jose_galvez_chimbote.webp" alt="José Gálvez" />
  </header>
  <div class="payment-register__body">
    <button type="button" class="payment-register__back" (click)="close()"><b>‹</b> Cambiar método de pago</button>
    <div class="payment-register__columns">
      <section class="payment-register__summary">
        <h2 id="payment-register-title">Emisor del banco BCP - Soles</h2>
        <h3>{{ account.holder }}</h3>
        <dl>
          <div><dt>Cuenta Corriente en soles:</dt><dd>{{ account.number }}</dd></div>
          <div><dt>Cuenta interbancaria CCI soles:</dt><dd>{{ account.interbank }}</dd></div>
        </dl>
        <h3>Resumen del pago</h3>
        <div class="payment-register__amounts">
          <p><span>Monto en soles</span><b>S/ {{ purchase.total().toFixed(2) }}</b></p>
          <p><span>Comisión</span><b>S/ 0.00</b></p>
          <p><span>Total a pagar</span><b>S/ {{ purchase.total().toFixed(2) }}</b></p>
        </div>
        @if (purchase.orderId()) { <p class="payment-register__order">ORDEN #{{ purchase.orderId() }}</p> }
      </section>
      <section class="payment-register__form">
        <h2>Registro del pago</h2>
        @for (record of paymentRecords(); track record.id) {
          <fieldset>
            <legend>Pago N°{{ record.id }} <span>⌃</span></legend>
            <div class="payment-register__row">
              <label>Moneda<select disabled><option>PEN - Soles</option></select></label>
              <label>Tipo de operación<select [(ngModel)]="record.operationType" [name]="'operationType-' + record.id"><option value="BANCA_MOVIL">Banca Móvil</option><option value="AGENCIA">Agencia</option><option value="TRANSFERENCIA_WEB">Transferencia web</option></select></label>
            </div>
            <div class="payment-register__row">
              <label>Código de Operación<input type="text" [(ngModel)]="record.operationNumber" [name]="'operationNumber-' + record.id" placeholder="WEB-558" /></label>
              <label>Monto<input type="text" [value]="'S/ ' + purchase.total().toFixed(2)" readonly /></label>
            </div>
            <label>Nota<textarea maxlength="50" [(ngModel)]="record.note" [name]="'note-' + record.id" placeholder="Adjunto váucher"></textarea><small>{{ record.note.length }}/50</small></label>
            <label class="payment-register__evidence">Adjuntar evidencia Bancaria:
              <input type="file" accept="image/*,.pdf" (change)="selectEvidence($event, record)" />
              <span><b>＋</b>{{ record.file?.name || 'Subir archivo' }}</span>
            </label>
          </fieldset>
        }
<button type="button" class="payment-register__submit" [disabled]="submitting()" (click)="sendReceipt($event)">{{ submitting() ? 'ENVIANDO...' : 'ENVIAR COMPROBANTE' }} <b>↗</b></button>
        @if (submitError()) { <p class="payment-register__error" role="alert">{{ submitError() }}</p> }
      </section>
    </div>
  </div>
</section>
